import React, { useEffect, useCallback } from 'react';
import { IAppExtensionPage } from '@msx/platform-services';
import { Shell } from '../core/components'
import { Routes } from './App.routes';
import { mergeStyles } from '@fluentui/react';
import { initializeIcons } from '@fluentui/react';

export interface Props {
}

export const App: (React.FC<Props>) = (props) => {

  useEffect(() => {
    const clarityinit = (projectid: string) => {
      if(!projectid) return
      (function (c, l, a, r, i, t, y) {
        console.log('clarity init;',projectid);
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", projectid);
    }
    
    clarityinit(process.env.REACT_APP_CLARITY_PROJECTID)
    
    // Disable console log on production
    if (process.env.REACT_APP_IS_PROD === 'true') {
      console.log = () => {}
    }
    
    // Inject some global styles
    mergeStyles({
      selectors: {
        ':global(body), :global(html), :global(#app)': {
          margin: 0,
          padding: 0,
          height: '100vh',
        }
      }
    });
    
    initializeIcons();
  }, []);

  const renderRoutes = useCallback((extensonPages: IAppExtensionPage[]) => {
    return <Routes extensonPages={extensonPages} />
  }, []);

  return <Shell onRenderRoutes={renderRoutes} />;
}


